export enum InventoryStatus {
  Offen = 'OFFEN',
  InBearbeitung = 'IN_BEARBEITUNG',
  Erfasst = 'ERFASST',
  Abgeschlossen = 'ABGESCHLOSSEN',
  // V2: Ueberfaellig = 'UEBERFAELLIG',
}
